import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getEnboxConfigurationState = createSelector(getDragonflyState, (state) => state?.enboxConfiguration);

export const getNameEnbox = createSelector(getEnboxConfigurationState, (state) => state?.nameEnbox);

export const getExternalIdEnbox = createSelector(getEnboxConfigurationState, (state) => state?.externalIdEnbox);

export const getAdmissionFeeEnbox = createSelector(getEnboxConfigurationState, (state) => state?.admissionFeeEnbox);

export const getCreditCostEnbox = createSelector(getEnboxConfigurationState, (state) => state?.creditCostEnbox);

export const getSegmentsRetentionDaysEnbox = createSelector(
  getEnboxConfigurationState,
  (state) => state?.segmentsRetentionDaysEnbox,
);

export const getBaseUrlEnbox = createSelector(getEnboxConfigurationState, (state) => state?.baseUrlEnbox);

export const getConnectionTimeoutEnbox = createSelector(
  getEnboxConfigurationState,
  (state) => state?.connectionTimeoutEnbox,
);

export const getReadTimeoutEnbox = createSelector(getEnboxConfigurationState, (state) => state?.readTimeoutEnbox);

export const getApiKeyEnbox = createSelector(getEnboxConfigurationState, (state) => state?.apiKeyEnbox);

export const getEmailNotifier = createSelector(getEnboxConfigurationState, (state) => state?.emailNotifier);

export const getLookBackDays = createSelector(getEnboxConfigurationState, (state) => state?.lookBackDays);

export const getLanguageEnbox = createSelector(getEnboxConfigurationState, (state) => state?.selectedLanguageEnbox);

export const getLanguageNamesEnbox = createSelector(
  getEnboxConfigurationState,
  (state) => state?.selectedLanguageEnbox?.map((lang) => lang.languageName) ?? [],
);

export const getLanguageCodesEnbox = createSelector(
  getEnboxConfigurationState,
  (state) => state?.selectedLanguageEnbox?.map((lang) => lang.languageCode) ?? [],
);

export const getStatusEnbox = createSelector(getEnboxConfigurationState, (state) => state?.isActiveEnbox);

export const getLanguages = createSelector(getEnboxConfigurationState, (state) => state?.languages);

export const getShowUpdateBtn = createSelector(getEnboxConfigurationState, (state) => state?.showUpdateBtn);

export const getDisableNameValue = createSelector(getEnboxConfigurationState, (state) => state?.disableName);

export const getRootConfigurationHelpTextStatus = createSelector(
  getEnboxConfigurationState,
  (state) => state?.rootConfigurationHelpTextStatus,
);

export const getCredentialsConfigurationHelpTextStatus = createSelector(
  getEnboxConfigurationState,
  (state) => state?.credentialsConfigurationHelpTextStatus,
);

export const getCampaignReportingHelpTextStatus = createSelector(
  getEnboxConfigurationState,
  (state) => state?.campaignReportingHelpTextStatus,
);

export const getEndpointConfigurationHelpTextStatus = createSelector(
  getEnboxConfigurationState,
  (state) => state?.endpointConfigurationHelpTextStatus,
);

export const getSelectedEnboxDataFromGrid = createSelector(
  getEnboxConfigurationState,
  (state) => state?.selectedEnboxDataFromGrid,
);

export const getShowCancelBtn = createSelector(getEnboxConfigurationState, (state) => state?.showCancelBtn);

export const getEnboxDataIsSubmitted = createSelector(getEnboxConfigurationState, (state) => state?.isSubmittedData);

export const getShowNameErrorMsg = createSelector(getNameEnbox, getEnboxDataIsSubmitted, (name, dataIsSubmitted) =>
  !name && dataIsSubmitted ? true : false,
);

export const getShowBaseUrlErrorMsg = createSelector(
  getBaseUrlEnbox,
  getEnboxDataIsSubmitted,
  (url, dataIsSubmitted) => (!url && dataIsSubmitted ? true : false),
);

export const getShowApiKeyErrorMsg = createSelector(
  getApiKeyEnbox,
  getEnboxDataIsSubmitted,
  getShowUpdateBtn,
  (apiKey, dataIsSubmitted, isEditMode) => (!apiKey && dataIsSubmitted && !isEditMode ? true : false),
);

export const getEmailNotifierErrorMsg = createSelector(
  getEmailNotifier,
  getEnboxDataIsSubmitted,
  (emailNotifier, dataIsSubmitted) =>
    emailNotifier &&
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/.test(emailNotifier) &&
    dataIsSubmitted
      ? true
      : false,
);

export const getLookBackDaysErrorMsg = createSelector(
  getLookBackDays,
  getEnboxDataIsSubmitted,
  (lookBackDays, dataIsSubmitted) =>
    (lookBackDays === null || lookBackDays < 2 || lookBackDays > 30) && dataIsSubmitted ? true : false,
);

export const getEnboxDataAreValid = createSelector(
  getNameEnbox,
  getBaseUrlEnbox,
  getApiKeyEnbox,
  getEmailNotifierErrorMsg,
  getLookBackDaysErrorMsg,
  getShowUpdateBtn,
  (name, baseURL, apiKey, emailNotifierError, lookBackDaysError, isEditMode) =>
    name && baseURL && (apiKey || isEditMode) && !emailNotifierError && !lookBackDaysError ? true : false,
);
